<script>
    import { Report, Toolbar } from '@manaakiwhenua/frag-svelte'
    import OurEnvironmentFooter from './OurEnvironmentFooter.svelte'

    // displays an error message in a Report, containing nothing but the toolbar, a close button and the error message

    export let errorMessage

    let rootElement;

    function closeReport() {
        if (rootElement) {
            const event = new CustomEvent('closeReport', { bubbles: true });
            rootElement.dispatchEvent(event);
        }
    }
</script>

<style>
    .report-root {
        display: flex;
        min-height: 100vh;
        flex-direction: column;
    }

    .report-root :global(.report-container) {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .report-root :global([data-action=print]) {
        display: none;
    }

    [slot="header"] {
        flex: 1;
    }

    [slot=closeButton] {
        position: absolute;
        top: 1em;
        right: 1em;
        border: none;
        background: transparent;
        margin: 0;
        padding: 0;
    }

    [slot=closeButton] > i.icon {
        position: static;
    }
</style>

<div class="report-root" bind:this={rootElement}>
    <Report categories={[]}
            header={null}
            isTopicPickerEnabled={false}>
        <div slot="toolbar">
            <Toolbar>
                <button class="close-button"
                        on:click={closeReport}
                        slot="closeButton">
                    <i class="icon icon-close_large"></i>
                </button>

            </Toolbar>
        </div>

        <div slot="header" style="padding: 1em; margin: 1em;">
            <h3>
                { errorMessage }
            </h3>
        </div>

        <div slot="footer">
            <OurEnvironmentFooter></OurEnvironmentFooter>
        </div>
    </Report>
</div>
